// Notification service using toast notifications
class NotificationService {
  constructor() {
    this.toasts = [];
    this.listeners = [];
  }

  // Subscribe to notification updates
  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  // Notify all subscribers
  notify() {
    this.listeners.forEach(callback => callback(this.toasts));
  }

  // Show success notification
  success(message, duration = 4000) {
    this.addToast('success', message, duration);
  }

  // Show error notification
  error(message, duration = 6000) {
    this.addToast('error', message, duration);
  }

  // Show warning notification
  warning(message, duration = 5000) {
    this.addToast('warning', message, duration);
  }

  // Show info notification
  info(message, duration = 4000) {
    this.addToast('info', message, duration);
  }

  // Add toast to queue
  addToast(type, message, duration) {
    const id = Date.now() + Math.random();
    const toast = {
      id,
      type,
      message,
      duration,
      timestamp: new Date()
    };

    this.toasts.push(toast);
    this.notify();

    // Auto remove after duration
    setTimeout(() => {
      this.removeToast(id);
    }, duration);
  }

  // Remove toast by id
  removeToast(id) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
    this.notify();
  }

  // Clear all toasts
  clear() {
    this.toasts = [];
    this.notify();
  }

  // Task-specific notifications
  taskAssigned(taskTitle, assigneeName) {
    this.success(`Đã giao công việc "${taskTitle}" cho ${assigneeName}`);
  }

  taskStatusChanged(taskTitle, newStatus) {
    const statusMap = {
      'todo': 'Cần làm',
      'in-progress': 'Đang làm', 
      'in-review': 'Đang kiểm tra',
      'done': 'Hoàn thành'
    };
    this.info(`Trạng thái công việc "${taskTitle}" đã chuyển thành: ${statusMap[newStatus]}`);
  }

  taskPriorityChanged(taskTitle, newPriority) {
    const priorityMap = {
      'low': 'Thấp',
      'medium': 'Trung bình',
      'high': 'Cao', 
      'critical': 'Khẩn cấp'
    };
    this.info(`Độ ưu tiên công việc "${taskTitle}" đã chuyển thành: ${priorityMap[newPriority]}`);
  }

  taskUnassigned(taskTitle) {
    this.info(`Đã bỏ giao công việc "${taskTitle}"`);
  }

  linkCopied() {
    this.success('Đã sao chép link vào clipboard!');
  }

  commentAdded(taskTitle) {
    this.success(`Đã thêm bình luận vào công việc "${taskTitle}"`);
  }
}

// Create singleton instance
const notificationService = new NotificationService();

export default notificationService; 
 